<script setup>
import { computed } from 'vue';
import { useStore } from 'vuex';

const store = useStore();

const user = computed(() => store.getters.getUserDetails);

const userRole = computed(() => {
    const attributes = user.value;
    
    if (!Array.isArray(attributes)) {
        return null; 
    }
    
    const roleAttr = attributes.find(attr => attr.Name === 'custom:role');
    
    return roleAttr ? roleAttr.Value : null;
});


</script>
<template>
  <!-- Main Wrapper -->
  <div class="main-wrapper">
    <layouts></layouts>
    <sidebar></sidebar>
    <div class="page-wrapper">
      <div class="content">
        <pageaddheader :title="title" :title1="title1" :items="userRole=='admin'?items:null" />

        <!-- /product list -->
        <div class="card">
          <div class="card-body">
            <div class="table-top">
              <div class="search-set">
                <div class="search-path">
                  <a
                    class="btn btn-filter"
                    id="filter_search"
                    v-on:click="filter = !filter; this.search=''"
                    :class="{ setclose: filter }"
                  >
                    <img src="../../../assets/img/icons/filter.svg" alt="img" />
                    <span
                      ><img src="../../../assets/img/icons/closes.svg" alt="img"
                    /></span>
                  </a>
                </div>
                <div class="search-input">
                  <a class="btn btn-searchset"
                    ><img src="../../../assets/img/icons/search-white.svg" alt="img"
                  /></a>
                  <div id="DataTables_Table_0_filter" class="dataTables_filter">
                    <label>
                      <input
                        type="search"
                        v-model="search"
                        class="form-control form-control-sm"
                        placeholder="Search..."
                        aria-controls="DataTables_Table_0"
                        @change="searching"
                      />
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <a-table
                :columns="columns"
                :data-source="filteredItems"
              >
                <template #bodyCell="{ column, record }">
                  <template v-if="column.key === 'categoryid'">
                    <div class="productimgname">
                      <a href="javascript:void(0);">{{ record.categoryname }}</a>
                    </div>
                  </template>
                  <template v-else-if="column.key === 'action' && userRole=='admin'">
                    <a class="me-3" @click="editcategory(record)" href="javascript:void(0);">
                      <img src="../../../assets/img/icons/edit.svg" alt="img" />
                    </a>
                    <a
                      class="me-3 confirm-text"
                      href="javascript:void(0);"
                      @click="showAlert(record.categoryid)"
                    >
                      <img src="../../../assets/img/icons/delete.svg" alt="img" />
                    </a>
                  </template>
                </template>
              </a-table>
            </div>
          </div>
        </div>
        <!-- /product list -->
      </div>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import { mapGetters } from 'vuex';

const columns = [
  {
    sorter: true,
  },
  {
    title: "Category Name",
    dataIndex: "categoryname",
    key: "categoryid",
    sorter: {
      compare: (a, b) => {
        a = a.categoryname.toLowerCase();
        b = b.categoryname.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Category Code",
    dataIndex: "categorycode",
    sorter: (a, b) => a.categorycode.localeCompare(b.code),
  },
  {
    title: "Description",
    dataIndex: "description",
    sorter: (a, b) => a.description.localeCompare(b.description),
  },
  {
    title: "Action",
    key: "action",
    sorter: true,
  },
];
export default {
  data() {
    return {
      filter: false,
      search: '',
      title: "Item Category list",
      title1: "View/Search Item Category",
      items: [
        {
          text: "Add Category",
          addname: "/addcategory",
        },
      ],
      data: null,
      columns,
      Choose: ["Choose Category", "Computers"],
      Category: ["Choose Sub Category", "Fruits"],
      Brand: ["Choose Sub Brand", "Iphone"],
    };
  },
  computed:{
    ...mapGetters(['getCurrentLocation']),

    currentLocation() { return this.getCurrentLocation; },
    
    locationName() {
      const loc = this.currentLocation;
      return loc ? Object.keys(loc) : null;
    },
    locationId() {
      const loc = this.currentLocation;
      return loc ? loc.id: null;
    },filteredItems() {
      return this.data?this.data.filter(item => {
        return !this.search || 
                item['categoryname'].toString().toLowerCase().includes(this.search.toLowerCase());
      }):null;
    },
  },
  methods: {
    handleKeydown(event) {
      if (this.$route.path === '/categorylist' && event.ctrlKey && (event.key === 'm') || event.ctrlKey && (event.key === 'M')) {
        event.preventDefault(); 
        
        this.$router.push('/addcategory');
      }
    },
    searching() {
      if (this.search) this.filter = true;
    },
    showAlert(id) {
      // Use sweetalert2
      Swal.fire({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        showCancelButton: true,
        confirmButtonColor: "#FF9F43",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!",
      }).then((result) => {
        if (result.isConfirmed) {
          axios
          .delete('/v1/category/'+id)
          .then(response => {
            //this.res = "Status " + response.status + ". Category created";
            Swal.fire("Deleted!", "Category has been deleted.");
            var index = this.data.findIndex(function(o){
              return o.categoryid === id;
            })
            if (index !== -1) this.data.splice(index, 1);
          })
          .catch(error => {
            console.log(error)
            Swal.fire(error.response.data.detail);
          });
          
        }
      });
    },
    editcategory(category) {
      this.$router.push({ path: '/editcategory', query: { id: category.categoryid } });
    },
    async getCategory() {
      axios
      .get(`/v1/category?locationid=${this.locationId}`)
      .then(response => {
        this.data = response.data
      })
      .catch(error => {
        console.log(error)
        this.errored = true
      });
    },
  },
  mounted() {
    document.addEventListener('keydown', this.handleKeydown);
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.handleKeydown);
  },
  beforeMount() {
    this.getCategory();
  },
  name: "categorylist",
};
</script>
<style>
.ant-tooltip {
  display: none !important;
}
</style>
